import { ReactNode } from "react"
import { HashPackWalletProvider } from "../../contexts/HashPackWalletContext"

export const AllWalletsProvider = (props: {
  children: ReactNode | undefined
}) => {
  return (
    <HashPackWalletProvider>
      {props.children}
    </HashPackWalletProvider>
  )
}
